/* global sat */

//
// Skyscanner Analytics Tag
// https://partnerportal.skyscanner.net/sat/documentation/
//

// Imports the Skyscanner Tag code.
(function(s,k,y,t,a,g){s['SkyscannerAnalyticsTag']=t;s[t]=s[t]||function(){ (s[t].buffer=s[t].buffer||[]).push(arguments)};s[t].u=y;var l=k.createElement("script"); l.src=y+"/tag.js";l.async=1;var h=k.getElementsByTagName("head")[0];h.appendChild(l); })(window, document, 'https://analytics.skyscanner.net', 'sat');

function isSkyscanner() {
    const market = document.getElementsByTagName("body")[0].getAttribute("market");
    return market === "skyscanner";
}

function stringToInteger(string) {
    return parseInt(string.match(/\d+/g).join(""));
}

function stringToFloat(string, currency) {
  if (['EUR', 'CHF'].includes(currency)) {
    return string.match(/\d+/g).join(".");
  } else {
    return parseInt(string.match(/\d+/g).join(""));
  }
}

function getLandingPageData() {
    const firstItineraryPrice = document.querySelector(".total-price .price");
    const currency = document.getElementsByTagName("body")[0].getAttribute("currency");
    return {
        priceSeen: firstItineraryPrice ? stringToFloat(document.querySelector(".total-price .price").innerText, currency) : null,
        currency: currency
    };
}

// This function calls the Skyscanner tag code to register a conversion.
// You should make sure to only fire this function once the page has finished loading.
// (For example, setting onload="fireSkyscannerTag();" attribute on the <body> tag).
export function fireLandingPage() {
    if (!isSkyscanner()) {
        return false;
    }

    // Initialise SAT with your Tracking Source ID
    sat("init", getTrackingID());

    // Send a 'landing' event
    sat("send", "landing", getLandingPageData());
}

function getConversionPageData() {
    return {
        bookingReference: document.getElementById("pnr").innerText
    };
}

function getTrackingID() {
    if (gon.layout === 'flysmarter') {
        return "SAT-883963-1";
    }

    return "SAT-783982-1";
}

// This function calls the Skyscanner tag code to register a conversion.
// You should make sure to only fire this function once the page has finished loading.
export function fireConversion() {
    if (!isSkyscanner()) {
        return false;
    }

    // Check if paid
    const elemPaid = document.querySelector(".payment-status .paid");
    if (elemPaid !== null) {
        // Initialise SAT with your Tracking Source ID
        sat("init", getTrackingID());

        // Send a 'conversion' event
        sat("send", "conversion", getConversionPageData());
    }
}
